export interface Deadline {deadlineAt:number|null;secondsLeft:number|null}
export interface DeadlineClock {deadlineAt:number;remaining:number;receivedAt:number}
export function captureDeadline(value:Deadline|undefined,now:number,wallNow:number=Date.now()):DeadlineClock|null {
 if(value?.deadlineAt==null||!Number.isFinite(value.deadlineAt))return null;
 return {deadlineAt:value.deadlineAt,remaining:typeof value.secondsLeft==='number'&&Number.isFinite(value.secondsLeft)?Math.max(0,value.secondsLeft):Math.max(0,(value.deadlineAt-wallNow)/1000),receivedAt:now};
}
export function deadlineText(clock:DeadlineClock|null,now:number,finished=false):string {
 if(!clock||finished)return '';
 const seconds=Math.max(0,Math.ceil(clock.remaining-(now-clock.receivedAt)/1000));
 if(seconds===0)return 'Срок сдачи наступил. Ожидаем обновление от сервера.';
 if(seconds<=180)return 'До срока сдачи: '+Math.floor(seconds/60)+':'+String(seconds%60).padStart(2,'0');
 return 'Срок сдачи: '+new Date(clock.deadlineAt).toLocaleString('ru-RU',{timeZone:'Europe/Moscow',day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})+' МСК';
}
export function deadlineMessage(event:{extended?:boolean;reason?:string}):string {
 return event.extended===true?'Срок продлён: никто не сдал ход. Период ещё не рассчитан.':'Срок сдачи наступил. Ожидаем обновление от сервера.';
}
